import styled from 'styled-components';
import { Upload } from 'antd';

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  .guide {
    font-size: 14px;
    color: #333;
  }
`;

export const StyledDragger = styled(Upload.Dragger)`
  &.ant-upload-wrapper .ant-upload-drag {
    background: #fafafa;
    border: 1px dashed #d9d9d9;
  }

  .ant-upload-drag-icon {
    margin: 8px 0 4px;
  }
  .ant-upload-text {
    font-weight: 500;
  }
  .ant-upload-hint {
    color: #999;
    font-size: 12px;
  }
`;

export const StyledDescription = styled.p`
  margin: 12px 0 0;
  font-size: 13px;
  color: #333;

  strong {
    color: #6200ea;
  }
  .invalid {
    color: #d46b08;
  }
`;

export const StyledGuideList = styled.ul`
  margin: 16px 0 0;
  padding-left: 18px;
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.8;
`;

/**
 * 템플릿 다운로드 버튼. 기존 Anchor(text 링크) 톤을 유지하되 S3 URL 의존을
 * 없애고 클릭 시 클라이언트에서 즉석 xlsx 생성.
 */
export const StyledTemplateButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  color: #6200ea;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #7c1ff5;
  }
`;
